import Auth from 'live/services/authorization'

export const canManageStacks = (): boolean => {
    return (
        Auth.Permission.isAdmin ||
        Auth.Permission.MANAGE_STACK_STATUS
    )
}
export const canViewStacks = (): boolean => {
    return (
        Auth.Permission.isAdmin ||
        Auth.Permission.MANAGE_STACK_STATUS ||
        Auth.Permission.VIEW_STACK_STATUS
    )
}